import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", {
  d: "M23.2975 11.927C23.2975 5.60913 18.1758 0.487495 11.858 0.487495C5.54009 0.487495 0.418457 5.60913 0.418457 11.927C0.418457 17.6368 4.60172 22.3693 10.0705 23.2275V15.2337H7.16598V11.927H10.0705V9.40674C10.0705 6.53971 11.7784 4.95605 14.3914 4.95605C15.643 4.95605 16.9521 5.17948 16.9521 5.17948V7.99467H15.5096C14.0886 7.99467 13.6454 8.87647 13.6454 9.78113V11.927H16.8181L16.3109 15.2337H13.6454V23.2275C19.1142 22.3693 23.2975 17.6368 23.2975 11.927Z",
  fill: "white"
}, null, -1)
const _hoisted_3 = [
  _hoisted_2
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _hoisted_3))
}